import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { environment } from '.../../environments/environment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Observable } from 'rxjs/Observable';

import { AuthService } from '../../_services/index';
import 'rxjs/add/operator/map';
import * as _ from 'underscore';
import { LoaderService } from 'app/_services/loader.service';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;

declare var $: any;
export const MY_FORMATS = {
	parse: {
		dateInput: 'LL'
	},
	display: {
		dateInput: 'LL',
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY'
	}
};
declare var MarkerClusterer: any;
declare var $: any;
declare var google: any;

declare var firebase: any;

interface Marker {
	lat: number;
	lng: number;
	label?: string;
	draggable?: boolean;
}

@Component({
	selector: 'app-ucc-potential',
	templateUrl: './ucc-potential.component.html',
	styleUrls: [ './ucc-potential.component.scss' ],
	providers: [
		{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [ MAT_DATE_LOCALE ] },
		{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
	]
})
export class UccPotentialComponent {
	prjId: any;
	userId: any;
	showLoader: any;
	dataRangeModal: any;
	startDate: any;
	endDate: any;
	defaultStartDate: any;
	defaultEndDate: any;
	public map: any;
	public bounds: any;
	public saerch: any;
	public date = moment();
	authtoken: any;
	polygondData: any;
	uccData: any;
	uccDataLength: any;
	uccReport: Object;
	wardList: any;

	constructor(
		private http: HttpClient,
		private auth: AuthService,
		private loaderService: LoaderService,
		public datepipe: DatePipe
	) {
		this.loaderService.status.subscribe((val: boolean) => {
			this.showLoader = val;
		});
		this.authtoken = JSON.parse(localStorage.getItem('authData'));
		var firstDay = new Date();
		var lastDay = new Date();
		this.defaultStartDate = firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
		this.defaultEndDate = firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
		this.dataRangeModal = {
			beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() },
			endDate: { year: lastDay.getFullYear(), month: lastDay.getMonth() + 1, day: lastDay.getDate() }
		};
	}

	getDataWhenProjectChange = async (id) => {
		$('#loderImgTab').show();
		this.loaderService.display(true);
		//this.renoveAllMarker();
		let polygon = await fetch(
			environment.apiUrl + 'entity/getPolygonByOemId' + '?prjid=' + id + '&wardOemId=null' + '&beatOemId=null',
			{
				method: 'get',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization: this.authtoken.token
				}
			}
		);
		this.polygondData = await polygon.json();
		this.clearFeature();
		this.map.data.addGeoJson(this.polygondData.geoJson);
		this.zoom(this.map, true);
		//this.setStyle(this);
		this.loaderService.display(false);

		$('.background').hide();
		$('#loderImgTab').hide();
		$('#progress-bar').hide();
	};

	// renoveAllMarker() {
	//  if (this.allMarkers.length > 0) {
	//      for (var i = 0; i < this.allMarkers.length; i++) {
	//          this.allMarkers[i].setVisible(false);
	//      }
	//  }
	// }

	clearFeature() {
		this.map.data.forEach((feature) => {
			this.map.data.remove(feature);
		});
	}

	/*
     process each lat long for fit bound
  */
	processPoints(this, geometry, callback, thisArg) {
		if (geometry instanceof google.maps.LatLng) {
			callback.call(thisArg, geometry);
		} else if (geometry instanceof google.maps.Data.Point) {
			callback.call(thisArg, geometry.get());
		} else {
			if (geometry) {
				geometry.getArray().forEach((g) => {
					this.processPoints(g, callback, thisArg);
				});
			}
		}
	}

	/*
   zoom into entity polygon
*/
	zoom(this, map, isZone) {
		this.bounds = new google.maps.LatLngBounds();
		this.map.data.forEach((feature) => {
			if (isZone) {
				this.processPoints(feature.getGeometry(), this.bounds.extend, this.bounds);
			} else {
				if (feature.getProperty('type') == 'route') {
					this.processPoints(feature.getGeometry(), this.bounds.extend, this.bounds);
				}
			}
		});
		map.fitBounds(this.bounds);
	}

	/* 
    zoom into particular Zone and Ward
*/
	zoomPolygon(this, map) {
		this.bounds = new google.maps.LatLngBounds();
		map.data.forEach((feature) => {
			this.processPoints(feature.getGeometry(), this.bounds.extend, this.bounds);
		});
		map.fitBounds(this.bounds);
	}

	getUCCConsumers() {
		this.loaderService.display(true);
		$('#totalVehicles').show();
		this.http
			.get(
				environment.apiUrl +
					'ucc/getUCCConsumers?' +
					'prjId=' +
					this.prjId +
					'&toDate=' +
					this.endDate +
					'&fromDate=' +
					this.startDate
			)
			.subscribe((data) => {
				console.log(data);
				this.uccData = data;
				console.log('Length', this.uccDataLength);
				this.plotStopPosition(this.uccData);
				this.highLightAssignBeat();
				this.loaderService.display(false);
				this.uccDataLength = this.uccData.length;
				$('#totalVehicles').hide();
			});
	}

	getUccPotential() {
		window.open(
			environment.apiUrl +
				'uccNew/getUCCPotentialReport?' +
				'prjId=' +
				this.prjId +
				'&fromDate=' +
				this.startDate +
				'&toDate=' +
				this.endDate
		);
	}

	// async getUCCConsumers() {
	//  this.loaderService.display(true);
	//  let area = await fetch(
	//      environment.apiUrl +
	//          'ucc/getUCCConsumers?' +
	//          'prjId=' +
	//          this.prjId +
	//          '&toDate=' +
	//          this.startDate +
	//          '&fromDate=' +
	//          this.endDate,
	//      {
	//          method: 'get',
	//          headers: {
	//              Accept: 'application/json',
	//              'Content-Type': 'application/json',
	//              Authorization: this.authtoken.token
	//          }
	//      }
	//  );
	//  this.uccData = await area.json();
	//  console.log('Length', this.uccDataLength);
	//  this.plotStopPosition(this.uccData);
	//  this.loaderService.display(false);
	//  this.uccDataLength = this.uccData.length;
	// }

	onDateRangeChanged(dataRange) {
		if (dataRange.beginDate.day > 0) {
			this.startDate = dataRange.beginDate.year + '-' + dataRange.beginDate.month + '-' + dataRange.beginDate.day;
			this.endDate = dataRange.endDate.year + '-' + dataRange.endDate.month + '-' + dataRange.endDate.day;
			this.getUCCConsumers();
		} else if (dataRange.beginDate.day == 0) {
			this.startDate = this.defaultStartDate;
			this.endDate = this.defaultStartDate;
			this.getUCCConsumers();
		}
	}

	plotStopPosition(stopInfo) {
       console.log('256',stopInfo);
	   

		this.clearStopMarker();
		var data = { features: [], type: '' };
		data.type = 'FeatureCollection';
		var coordinates = [];
		var stop = 0;
		var totalDuration = 0;
		for (var i = 0; i < stopInfo.length; i++) {
			if (stopInfo[i].lng && stopInfo[i].lat) {
				stop++;
				var geometry = { coordinates: [], type: '' };
				geometry.coordinates.push(Number(stopInfo[i].lng), Number(stopInfo[i].lat));
				geometry.type = 'Point';
				var collectionDate = this.datepipe.transform(stopInfo[i].collectiondate, 'dd-MM-yyyy');
				console.log('Collection Dqt', collectionDate);
				data.features.push({
					geometry: geometry,
					type: 'Feature',
					properties: {
						CONSUMERNAME: stopInfo[i].ConsumerName,
						ADDRESS: stopInfo[i].Address,
						HOUSE: stopInfo[i].HouseNo,
						VEHICLENO: stopInfo[i].VEHNO,
						WARD: stopInfo[i].WardID,
						ZONE: stopInfo[i].ZoneId,
						DENO: stopInfo[i].Denomination,
						CREATEDBY: stopInfo[i].createdby,
						CREATEDDATE: stopInfo[i].CreateDate,
						BILLMONTH: stopInfo[i].billMonth,
						COLLECTIONDATE: collectionDate,
						TYPE: 'uccPoint',
						number: stop
					}
				});
			}
		}
		this.map.data.addGeoJson(data);
	}

	highLightAssignBeat() {
		this.map.data.setStyle(function(feature) {
			var color = feature.getProperty('FillColor');
			var strokeColor = feature.getProperty('Bcolor');
			if (feature.getProperty('TYPE') == 'uccPoint') {
				var icon = 'assets/img/home.png';
				return {
					fillColor: color,
					strokeColor: strokeColor,
					strokeWeight: 2,
					fillOpacity: 0.05,
					icon: icon,
					strokeopacity: 0.2
				};
			}
		});
	}

	clearStopMarker() {
		this.map.data.forEach((feature) => {
			if (feature.getProperty('TYPE') == 'uccPoint') {
				this.map.data.remove(feature);
			}
		});
	}

	ngOnInit() {
		this.prjId = this.auth.getAuthentication().projectId;
		this.userId = this.auth.getAuthentication().id;
		this.getDataWhenProjectChange(this.prjId);
		this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
		this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
		this.getUCCConsumers();

		$('#totalVehicles').hide();
		var infoWindow;
		var lastOpenedInfoWindow;
		var thisRef = this;
		$('#loderImgTab').hide();

		this.map = new google.maps.Map(document.getElementById('map'), {
			zoom: 16,
			center: { lat: 28.47769599987369, lng: 77.06160699973178 }
		});

		infoWindow = new google.maps.InfoWindow();
		this.map.data.setStyle(function(feature) {
			var color = feature.getProperty('FillColor');
			var strokeColor = feature.getProperty('Bcolor');
			var strokeOpacity = feature.getProperty('stroke-opacity');
			return {
				fillColor: color,
				strokeColor: strokeColor,
				strokeWeight: 1,
				fillOpacity: 0,
				strokeopacity: 0.7,
				content: 'AREA_1'
			};
		});
		this.map.data.addListener('click', showArrays);

		// show info window
		function showArrays(event) {
			closeLastOpenedInfoWindow();
			var position = { lat: event.latLng.lat(), lng: event.latLng.lng() };
			var content =
				'<div>' +
				'<h4 style="font-weight:bold;">Household and UCC Collection</h4><hr style="border-top:1px solid #afafaf;margin:5px;">' +
				'<div><div><p><strong>Bill Month: </strong>' +
				event.feature.getProperty('BILLMONTH') +
				'</p><p><strong>Vehicle No: </strong>' +
				event.feature.getProperty('VEHICLENO') +
				'</p>' +
				'<p><strong>Denomination : </strong>' +
				event.feature.getProperty('DENO') +
				'</p>' +
				'<p><strong>Collection Date: </strong>' +
				event.feature.getProperty('COLLECTIONDATE') +
				'</p>' +
				'<p><strong>Created By : </strong>' +
				event.feature.getProperty('CREATEDBY') +
				'</p>' +
				'</div></div>';
			infoWindow = new google.maps.InfoWindow({
				content: content,
				position: position
			});

			google.maps.InfoWindowOptions;
			var marker = new google.maps.Marker({
				position: position,
				map: this.map,
				zoom: 16,
				visible: false
			});
			infoWindow.open(this.map);
			lastOpenedInfoWindow = infoWindow;
			/* Since this div is in a position prior to .gm-div style-iw.
       * We use jQuery and create a iwBackground variable,
       * and took advantage of the existing reference .gm-style-iw for the previous div with .prev().
      */
		}

		function closeLastOpenedInfoWindow() {
			if (lastOpenedInfoWindow) {
				lastOpenedInfoWindow.close();
			}
		}

		//search box

		let input = document.getElementById('pac-input');
		let searchBox = new google.maps.places.SearchBox(input);
		this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
		// Bias the SearchBox results towards current map's viewport.

		var markers = [];
		// Listen for the event fired when the user selects a prediction and retrieve
		// more details for that place.
		searchBox.addListener('places_changed', function(this) {
			let places = searchBox.getPlaces();
			if (places.length == 0) {
				return;
			}
			// Clear out the old markers.
			markers.forEach(function(marker) {
				marker.setMap(null);
			});
			markers = [];
			// For each place, get the icon, name and location.
			let bounds = new google.maps.LatLngBounds();
			places.forEach(function(place) {
				if (!place.geometry) {
					console.log('Returned place contains no geometry');
					return;
				}
				var icon = {
					url: place.icon,
					size: new google.maps.Size(71, 71),
					origin: new google.maps.Point(0, 0),
					anchor: new google.maps.Point(17, 34),
					scaledSize: new google.maps.Size(25, 25)
				};
				// Create a marker for each place.
				markers.push(
					new google.maps.Marker({
						map: thisRef.map,
						icon: icon,
						title: place.name,
						position: place.geometry.location
					})
				);

				if (place.geometry.viewport) {
					// Only geocodes have viewport.
					bounds.union(place.geometry.viewport);
				} else {
					bounds.extend(place.geometry.location);
				}
			});
			thisRef.map.fitBounds(bounds);
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/maptracker/stop/ucc-potential.component.ts